import { Typography } from "@mui/material";

export default () => (
  <Typography variant="h4" color="gold" textAlign="center">
    Worderize
  </Typography>
);
